import React from "react";


import { connect } from "react-redux";
import { Bar } from "react-chartjs-2";


class CashBackGraph extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			durationList: [
				{ value: "Select", label: "Select" },
				{ value: "3", label: "3 months" },
				{ value: "6", label: "6 months" },
				{ value: "12", label: "1 year" }
			],
			durationSelected: '3',
			graphRes: ''
		}
	}

	componentDidMount() {
		this.loadGraph('3');
	}
	componentWillUnmount() {
	}
	durationSelect = (event) => {
		if (event.target.value == 'Select') {
			alert('Please select a duration');

		} else {
			this.setState({
				durationSelected: event.target.value
			})
			this.loadGraph(event.target.value);
		}
	}

	loadGraph(durationSelected) {
		// store.dispatch(setGraphResponse('loading'));

		var graphMonthList = [];
		var defaultMonthList = [];
		var successAmountList = [];
		var failureAmountList = [];
		var reversalAmountList = [];

		var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug",
			"Sep", "Oct", "Nov", "Dec"];

		var today = new Date();
		var d;
		var month;

		for (var i1 = durationSelected - 1; i1 >= 0; i1 -= 1) {
			d = new Date(today.getFullYear(), today.getMonth() - i1, 1);
			var y = d.getFullYear().toString().substring(2, 4);
			month = monthNames[d.getMonth()];
			var values = month + " " + y;
			defaultMonthList.push(values);
		}

		var graphRes = {
			mapKeyList: defaultMonthList,
			successAmountList: successAmountList,
			failureAmountList: failureAmountList,
			reversalAmountList: reversalAmountList
		}



		this.setState({
			graphRes: graphRes
		})

		this.setState({
			graphMapLength: defaultMonthList.length
		})


		// const headers = {
		// 	'Authorization': 'Bearer ' + this.props.token,
		// 	'client-id': this.props.agentInfo.id,
		// 	'role': this.props.clientRole,
		// }

		// var graphUrl = '/api/v1/dmt/statistics/' + this.props.agentInfo + '/' +
		// 	durationSelected;

		// httpClient.get(graphUrl,
		// 	{ headers }
		// ).then((response) => {
		// 	console.log('graph response' + JSON.stringify(response.data));
		// 	const map = new Map(Object.entries(response.data.data));
		// 	// const map = new Map(Object.entries({}));
		// 	var itr = map.keys();

		// 	for (var i = 0; i < map.size; i++) {
		// 		graphMonthList.push(itr.next().value);

		// 	}


		// 	var newArray = [];

		// 	for (var i = 0; i < defaultMonthList.length; i++) {
		// 		if (!graphMonthList.includes(defaultMonthList[i])) {
		// 			newArray.push(defaultMonthList[i]);
		// 		}
		// 	}


		// 	if (newArray.length > 0) {
		// 		for (var k = 0; k < newArray.length; k++) {

		// 			var successAmount = 0;
		// 			successAmountList.push(successAmount);

		// 			var failedAmount = 0;
		// 			failureAmountList.push(failedAmount);

		// 			var reversalAmount = 0;
		// 			reversalAmountList.push(reversalAmount);
		// 		}
		// 	}



		// 	if (graphMonthList.length > 0) {
		// 		for (var i = 0; i < graphMonthList.length; i++) {
		// 			var index = defaultMonthList.indexOf(graphMonthList[i]);
		// 			var successAmount = map.get(graphMonthList[i]).successAmount;
		// 			//successAmountList.push(successAmount);
		// 			successAmountList[index] = successAmount;

		// 			var failedAmount = map.get(graphMonthList[i]).failedAmount;
		// 			//failureAmountList.push(failedAmount);
		// 			failureAmountList[index] = failedAmount;

		// 			var reversalAmount = map.get(graphMonthList[i]).reversalAmount;
		// 			// reversalAmountList.push(reversalAmount);
		// 			reversalAmountList[index] = reversalAmount;
		// 		}
		// 	}

		// 	var graphRes = {
		// 		mapKeyList: defaultMonthList,
		// 		successAmountList: successAmountList,
		// 		failureAmountList: failureAmountList,
		// 		reversalAmountList: reversalAmountList
		// 	}



		// 	this.setState({
		// 		graphRes: graphRes
		// 	})

		// 	this.setState({
		// 		graphMapLength: defaultMonthList.length
		// 	})



		// 	//store.dispatch(setGraphResponse(response.data));

		// }).catch(error => {
		// 	var data = null;
		// 	var response = {
		// 		data: data
		// 	}
		// 	//store.dispatch(setGraphResponse('error'));

		// 	console.log('graph service error...' + error);
		// 	// if (error.message.includes("401")) {
		// 	// 	tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
		// 	// } else {

		// 	// }

		// });
	}
	render() {

		return (
			<div class="card">
				<div class="dashhead">
					<h3>Cashback Amount</h3>
					<select class="form-select" id="monthId" aria-label=""
						onChange={this.durationSelect}>

						{this.state.durationList.map(duration => (
							<option value={duration.value}
							>{duration.label}</option>
						))}

					</select>
				</div>
				<div class="grapreport">
					<p>Showing Graph For: Last {this.state.durationSelected} months</p>

					<Bar
						data={
							{
								labels: this.state.graphRes.mapKeyList,
								datasets: [
									{
										label: 'Cashback Received',
										data: [212345, 404545, 273268, 197765, 246885, 304545],
										backgroundColor: '#8cc342',
									},
									{
										label: 'Cashback Eligible',
										data: [42345, 34545, 73268, 97765, 46885, 54545],
										backgroundColor: '#a6b6c1',
									},
								]
							}
						}
						options={
							{
								plugins: {
									legend: { display: false },
								},
								scales: {
									x: {
										stacked: true,
									},
									y: {
										stacked: true,
										ticks: { display: false },
									},
								}
							}
						}
					/>

					{/* <canvas id="mycashback" width="400" height="183"></canvas> */}
				</div>
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
		miscReduce: { otpRefNo, phone } }
) => ({
	errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone
});

export default connect(mapStateToProps, null)(CashBackGraph);
